export class CouponLimitPerCustomerExceededWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponLimitPerCustomerExceeded');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'ERROR_COUPON_LIMIT_PER_CUSTOMER_EXCEEDED';
    this.name = 'CouponLimitPerCustomerExceeded';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponLimitPerCustomerExceeded',
      applicationCode: 'ERROR_COUPON_LIMIT_PER_CUSTOMER_EXCEEDED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

export class CouponIsDisabledWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponIsDisabled');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'ERROR_COUPON_IS_DISABLED';
    this.name = 'CouponIsDisabled';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponIsDisabled',
      applicationCode: 'ERROR_COUPON_IS_DISABLED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

export class CouponUsageExceededWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponUsageExceeded');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'ERROR_COUPON_USAGE_EXCEEDED';
    this.name = 'CouponUsageExceeded';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponUsageExceeded',
      applicationCode: 'ERROR_COUPON_USAGE_EXCEEDED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

export class CouponHasExpiredWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponHasExpired');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'ERROR_COUPON_HAS_EXPIRED';
    this.name = 'CouponHasExpired';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponHasExpired',
      applicationCode: 'ERROR_COUPON_HAS_EXPIRED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

export class CouponIsNotActiveYetWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponIsNotActiveYet');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'ERROR_COUPON_IS_NOT_ACTIVE_YET';
    this.name = 'CouponIsNotActiveYet';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponIsNotActiveYet',
      applicationCode: 'ERROR_COUPON_IS_NOT_ACTIVE_YET',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

export class CouponDoesNotExistWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CouponDoesNotExist');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'ERROR_COUPON_DOES_NOT_EXIST';
    this.name = 'CouponDoesNotExist';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CouponDoesNotExist',
      applicationCode: 'ERROR_COUPON_DOES_NOT_EXIST',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}
